import React from "react";

import "./amountIncrease.css";

interface AmountIncreaseProps {
    onChange: (v: number) => void;
    amount: number;
    placeholder?: string;
}

export default function AmountIncrease(props: AmountIncreaseProps) {
    return <div className="amount-increase">
        <a className="btn unselectable" onClick={() => {
            props.onChange(props.amount-1);
        }}>-</a>
        <a>{props.placeholder ? props.placeholder : props.amount}</a>
        <a className="btn unselectable" onClick={() => {
            props.onChange(props.amount+1);
        }
            
        }>+</a>
    </div>;
}